import React, { PureComponent } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Map, is, List } from 'immutable';
import { TransitionGroup } from 'react-transition-group';
import connect from '../store/connect';
import { FadeInInline, FadeInInline2 } from '../styles/helpers/animations';
import { color, breakpoint } from '../styles/helpers/variables';
import { fontFamilyBody } from '../styles/helpers/mixins';
import { setViewstate, removeViewstate } from '../actions/actionCreators';

class MenuCart extends PureComponent {
  static getTotalCartItems(cart) {
    return cart.get('cart', Map()).reduce((memory, item) => memory + item.get('quantity'), 0);
  }

  constructor(props) {
    super(props);
    this.state = {
      totalCartItems: 0,
      displayNumber: 0
    };
    this.toggleCart = this.toggleCart.bind(this);
    this.updateCart = this.updateCart.bind(this);
  }

  componentDidMount() {
    this.updateCart(this.props.cart);
  }

  componentWillReceiveProps(nextProps) {
    if (!is(this.props.cart, nextProps.cart)) {
      this.updateCart(nextProps.cart);
    }
    const propsCartItems = this.constructor.getTotalCartItems(this.props.cart);
    const nextPropsCartItems = this.constructor.getTotalCartItems(nextProps.cart);
    if (propsCartItems < nextPropsCartItems && this.props.viewstate.get('productAddedToCart')) {
      this.handleProductAddedToCart();
    }
  }

  handleProductAddedToCart() {
    this.props.setViewstate('cartActive', true);
  }

  toggleCart() {
    this.props.removeViewstate('globalSearchActive');
    if (this.props.cart.get('cart', List()).isEmpty()) {
      this.props.setViewstate('cartActive', false);
    } else {
      this.props.setViewstate('cartActive', !this.props.viewstate.get('cartActive'));
    }
  }

  updateCart(cart) {
    const totalCartItems = this.constructor.getTotalCartItems(cart);

    this.setState({
      totalCartItems,
      displayNumber: this.state.displayNumber === 0 ? totalCartItems : null
    });

    if (this.state.displayNumber !== 0) {
      setTimeout(() => {
        this.setState({
          displayNumber: totalCartItems
        });
      }, 250);
    }
  }

  render() {
    const { totalCartItems, displayNumber } = this.state;
    return (
      <SideMenuLink onClick={this.toggleCart} hasCartItems={totalCartItems >= 1}>
        <CartContentWrapper hasCartItems={totalCartItems >= 1} bg="/images/icons/shopping.svg">
          <DisplayInlineOnLarge>Varukorg</DisplayInlineOnLarge>
          {totalCartItems > 0 && <DisplayInlineOnLarge>&nbsp;</DisplayInlineOnLarge>}
          {totalCartItems > 0 && '('}
          <TransitionGroup>{displayNumber && <FadeInInline>{displayNumber}</FadeInInline>}</TransitionGroup>
          {totalCartItems > 0 && ')'}
          <TransitionGroup>
            {totalCartItems > 0 && (
              <FadeInInline2>
                <CheckmarkIcon src="/images/icons/checkmark.svg" />
              </FadeInInline2>
            )}
          </TransitionGroup>
        </CartContentWrapper>
      </SideMenuLink>
    );
  }
}

const SideMenuLink = styled.button`
  ${fontFamilyBody};
  position: relative;
  margin: 0;
  padding: 0;
  background-color: transparent;
  outline: 0;
  cursor: ${props => (props.hasCartItems ? 'pointer' : 'default')};
  border: none;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 1.5px;
  color: ${color.white};
  text-decoration: none;
  text-transform: uppercase;
  transition: opacity 250ms ease-out;
`;

const CartContentWrapper = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  transition: opacity 0.25s ease-out;
  &:hover {
    opacity: ${props => (props.hasCartItems ? 0.875 : 1)};
  }
  &:active {
    opacity: ${props => (props.hasCartItems ? 0.75 : 1)};
  }
  &:after {
    content: '';
    position: relative;
    display: inline-block;
    margin-left: 5px;
    background-image: ${props => props.bg && `url(${props.bg})`};
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    width: 17.5px;
    height: 17.5px;
    @media screen and (min-width: ${breakpoint.large}px) {
      width: 20px;
      height: 20px;
    }
  }
`;
const DisplayInlineOnLarge = styled.span`
  display: none;
  @media screen and (min-width: ${breakpoint.large}px) {
    display: inline;
  }
`;

const CheckmarkIcon = styled.img`
  display: block;
  height: 7px;
  width: 7px;
  position: absolute;
  top: calc(50% - 1px);
  right: 5px;
  @media screen and (min-width: ${breakpoint.large}px) {
    height: 8px;
    width: 8px;
    top: calc(50% - 2px);
    right: 6px;
  }
`;

MenuCart.defaultProps = {
  viewstate: Map(),
  cart: Map()
};

MenuCart.propTypes = {
  viewstate: PropTypes.instanceOf(Map),
  cart: PropTypes.instanceOf(Map),
  setViewstate: PropTypes.func.isRequired,
  removeViewstate: PropTypes.func.isRequired
};

export default connect(MenuCart, { setViewstate, removeViewstate }, store => ({
  viewstate: store.viewstate,
  cart: store.cart
}));



// WEBPACK FOOTER //
// ./src/components/MenuCart.js